import { fetch } from '@/utils/fetch'
import { LayoutDetail, RegionList } from './countyLayout.model'

/**
 * 获取新站上新覆盖率列表（如上海-闵行区 10%）
 */
export function regionDetailApi(coverage_station_code: string, region_code: string) {
  return fetch.get('charge-map/v1/station-coverage/detail', {
    params: {
      coverage_station_code,
      region_code,
    },
    wrapper: LayoutDetail,
  })
}

/**
 * 地图图层满足条件覆盖率区域code查询（用于行政区域边界数据查询）
 * https://apidoc.nioint.com/project/10079/interface/api/1502957
 */
export function regionCodesApi(
  coverage_station_code: string,
  region_code: string,
  coverage_layer_show_mode: string
) {
  return fetch.get('charge-map/v1/station-coverage/regions', {
    params: {
      coverage_station_code,
      region_code,
      coverage_layer_show_mode,
    },
    wrapper: RegionList,
  })
}
